<div id="{{ 'choice-validation-' + name }}" uk-modal>
    <div class="uk-modal-dialog">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div class="uk-modal-body">
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <p class="bold color-grey uk-margin-small-bottom">
                    Êtes-vous sûr de vouloir faire cette action?
                </p>
            </div>
        </div>
        <div class="uk-modal-footer">
            <p class="uk-text-right">
                <button class="button bold uk-modal-close" type="button" (click)="sendResponse(false)">
                    Non
                </button>
                <button class="button bold uk-margin-small-left uk-modal-close" type="submit" (click)="sendResponse(true)">
                    Oui
                </button>
            </p>
        </div>
    </div>
</div>